import { ValidationErrors } from '@angular/forms';

const MIDDLE_NAME_ERROR_MESSAGES: ValidationErrors = {
  pattern: () => 'Middle Name should have a valid format',
};

const LAST_NAME_ERROR_MESSAGES: ValidationErrors = {
  required: () => 'Last Name is required.',
  minlength: () => 'Last Name must be at least 2 characters long.',
  pattern: () => 'Last Name should have a valid format',
};

const PHONE_NUMBER_ERROR_MESSAGES: ValidationErrors = {
  pattern: () => 'Phone Number should has a correct format.',
};

const USERNAME_ERROR_MESSAGES: ValidationErrors = {
  required: () => 'Username is required.',
  minlength: () => 'Username must be at least 2 characters long.',
};

export const CREATE_APPLICATION_GUARDIANSHIP_ERROR_MESSAGES = {
  middle_name: MIDDLE_NAME_ERROR_MESSAGES,
  last_name: LAST_NAME_ERROR_MESSAGES,
  phone_number: PHONE_NUMBER_ERROR_MESSAGES,
  username: USERNAME_ERROR_MESSAGES,
} as const;
